export default {
    path: '/building-materials-warehouse',
    name: 'BuildingMaterialsWarehouse',
    component: () => import('@/layout/index.vue'),
    // redirect: {
    //     name: "EquipmentMasterData"
    // },
    meta: {
        title: '间材库',
        icon: 'iconfont icon-jianzhujiancai4',
        role: 'BACK_MENU4'
    },
    children: [{
            path: '/stockAuxiStock',
            name: 'StockAuxiStock',
            meta: {
                title: '采购入库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M1'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/StockAuxiStock.vue'),
        },{
            path: '/IsRetrieval',
            name: 'IsRetrieval',
            meta: {
                title: 'IS出库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M2'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/IsRetrieval.vue'),
        }, {
            path: '/PutawayConfirmAuxi',
            name: 'PutawayConfirmAuxi',
            meta: {
                title: '间材上架',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M3'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/PutawayConfirmAuxi.vue'),
        },
        {
            path: '/InterstitialMaterial',
            name: 'InterstitialMaterial',
            meta: {
                title: '库存',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M4'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/InterstitialMaterial.vue'),
        },
        {
            path: '/MaterialUnpackingPackage',
            name: 'MaterialUnpackingPackage',
            meta: {
                title: '拆包',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M5'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/MaterialUnpackingPackage.vue'),
        },
        {
            path: '/MaterialTransfer',
            name: 'MaterialTransfer',
            meta: {
                title: '物料移库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M6'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/MaterialTransfer.vue'),
        },
        {
            path: '/IntermediateMaterialTransaction',
            name: 'IntermediateMaterialTransaction',
            meta: {
                title: '交易类型',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M7'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/IntermediateMaterialTransaction.vue'),
        },
        {
            path: '/IntermediateItem',
            name: 'IntermediateItem',
            meta: {
                title: '间材信息',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M8'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/IntermediateItem.vue'),
        },
        {
            path: '/getApply',
            name: 'GetApply',
            meta: {
                title: '领用申请',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M9'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/GetApply.vue'),
        },
        {
            path: '/getApplyExamine',
            name: 'GetApplyExamine',
            meta: {
                title: '领用审批',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M10'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/GetApplyExamine.vue'),
        },
        {
            path: '/PickingMat',
            name: 'PickingMat',
            meta: {
                title: '间材拣货',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M11'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/PickingMat.vue'),
        },
        {
            path: '/getDistribute',
            name: 'GetDistribute',
            meta: {
                title: '领用出库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU4_M12'
            },
            component: () => import('@/views/buildingMaterialsWarehouse/GetDistribute.vue'),
        },
        {
            path: '/interstitialMaterialWriteXa',
            name: 'InterstitialMaterialWriteXa',
            component: () => import('@/views/buildingMaterialsWarehouse/InterstitialMaterialWriteXa.vue'),
            meta: {
                title: '间材交易记录',
                role: 'BACK_MENU4_M13'
            }
        }
    ],
}